import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "../components/Typography";
import SearchSets from "../assets/search-sets.png";
import { X, XCircle, CheckCircle, PlusCircle, MagnifyingGlass } from "@phosphor-icons/react";
import { fetchWatchlistStocks, fetchStockInfo, fetchStockHistory, fetchStocks } from "../models/marketsService";
import { spacing, borderRadius } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import Card, { CardContent } from "./TakashiCard";
import SparklineChart from "./SparklineChart";
import "./MarketsView.css";
import wsjRecommendations from "../models/wsjRecommendations.json";


const CreateWatchlist = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [watchlistName, setWatchlistName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [recommendedResults, setRecommendedResults] = useState([]);
  const [selectedStocks, setSelectedStocks] = useState([]);

  let searchTimeout = null; // ✅ Store timeout reference

    // ✅ Handle Stock Search
    // const handleSearch = async (query) => {
    //   setSearchQuery(query);
    //   if (query.length > 1) {
    //     const results = await fetchStocks(query); // Fetch stock data from API
    //     console.log(results);
    //     setSearchResults(results);
    //   } else {
    //     setSearchResults([]);
    //   }
    // };

    const isStockValid = (stock) => {
      return stock.price && stock.price > 0; // ✅ Ensures price exists and is greater than 0
    };
    

const getStockInfo = async (results) => {

  console.log(results);
  // ✅ Store initial results without historical data
  setSearchResults(results.map(stock => ({
    ticker: stock.ticker,
    name: stock.name,
    price: stock.lastTrade?.p || stock.day?.c || 0,
    change: stock.todaysChangePerc || 0,
    history: [], // Placeholder for sparkline data
    isValid: true
  })));

  // ✅ Clear any existing timeout
  if (searchTimeout) clearTimeout(searchTimeout);

  // ✅ Wait 2 seconds before fetching historical data
  searchTimeout = setTimeout(async () => {
    try {
      // ✅ Fetch historical data and update state
      const formattedResults = await Promise.all(results.map(async (stock) => {
        const response = await fetchStockInfo(stock.ticker);
        console.log(response.status);
        const { normalizedHistory } = await fetchStockHistory(stock.ticker);
        const minPrice = stock.day?.l || stock.min?.l || 0;
        const maxPrice = stock.day?.h || stock.min?.h || 1;

        const actualHistory = normalizedHistory.map(normValue => 
          minPrice + (normValue * (maxPrice - minPrice))
        );

        const latestHistoryPrice = actualHistory.length > 0 ? actualHistory[actualHistory.length - 1] : null;
        const latestPrice = response.ticker.min?.c || response.ticker.day?.c || latestHistoryPrice || stock.lastTrade?.p || stock.min?.c || stock.day?.c || 0;
        return {
          ticker: stock.ticker,
          name: stock.name,
          price: latestPrice || stock.lastTrade?.p || stock.day?.c || 0,
          change: response.ticker.todaysChangePerc || 0,
          history: normalizedHistory, // ✅ Update with sparkline data
          isValid: latestPrice !== 0
        };
      }));

      console.log(formattedResults);

      // ✅ Merge updated results into state
      setSearchResults(formattedResults);
    } catch (error) {
      console.error("Error fetching stock history:", error);
    }
  }, 100); // ✅ 2-second delay for historical data
}

useEffect(() => {
  getStockInfo(wsjRecommendations); // ✅ Load "Based on WSJ Reading" stocks by default
}, []);

    const handleSearch = async (query) => {
      setSearchQuery(query);
      setSearchResults([]); // ✅ Clear previous results immediately
    
      if (query.length > 1) {
        try {
          // ✅ Fetch stock list immediately
          const results = await fetchStocks(query);
          console.log("Fetched Stocks:", results);
          getStockInfo(results);
          
        } catch (error) {
          console.error("Error fetching stock search results:", error);
        }
      }
    };
  

  // ✅ Select/Deselect Stocks
  const toggleStockSelection = (stock) => {
    if (selectedStocks.find((s) => s.ticker === stock.ticker)) {
      setSelectedStocks(selectedStocks.filter((s) => s.ticker !== stock.ticker)); // Remove
    } else {
      setSelectedStocks([...selectedStocks, stock]); // Add
    }
  };

  // ✅ Save Watchlist
  const handleSaveWatchlist = () => {
    if (!watchlistName.trim()) {
      alert("Please enter a watchlist name.");
      return;
  }
    const watchlist = { 
        id: "" + Date.now(), 
        name: watchlistName, 
        stocks: selectedStocks.map(stock => stock.ticker) // ✅ Save only ticker symbols
    };

    const storedWatchlists = JSON.parse(localStorage.getItem("watchlists")) || [];
    localStorage.setItem("watchlists", JSON.stringify([...storedWatchlists, watchlist]));

    navigate("/markets/watchlist/" + watchlist.id);
};

const handlePreviewWatchlist = () => {
  if (selectedStocks.length === 0) return;

  navigate("/create-watchlist/preview", {
    state: { watchlistName, selectedStocks }
  });
};


  return (
    <div className="search-controller" style={{ backgroundColor: theme.colors.fillPrimary }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

        <X size={24} onClick={() => navigate(-1)} style={{ cursor: "pointer" }} />
      </div>

      {/* Input: Watchlist Name */}
      <div className="naming">
        <input
          type="text"
          placeholder="Name your watchlist..."
          value={watchlistName}
          onChange={(e) => setWatchlistName(e.target.value)}
        />
      </div>

      {/* Search Input */}

      <div className="search-container">
      <div       className="stock-searchInput">
      <MagnifyingGlass size={24}/>

      <input
        type="text"
        placeholder="Search stocks..."
        value={searchQuery}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ width: "100%", padding: spacing.s, borderRadius: borderRadius.s, }}
        >
      </input>
      <XCircle size={24} weight="fill" color="#6F6F6F"
        onClick={() => {
          setSearchQuery("");
          setSearchResults([]);
          setSearchResults(wsjRecommendations);
        }}
      />
        </div>
        <button
        onClick={() => navigate(-1)} style={{ cursor: "pointer" }}
        >Cancel</button>
          </div>

          {searchQuery.length === 0 && (
      <>
        <div className="search-sets-container">
          <img className="search-sets" src={SearchSets}></img>
          </div>
              <div className="search-ui-helper">
              <div>
                <Typography variant="headlineMedia" style={{padding: "0 16px"}}>Pick Based on Your WSJ Reading</Typography>
                {recommendedResults.map((stock) => (
                  <Card key={stock.ticker} className="card">
                    <CardContent>
                      <div className="CompanyDetails">
                        <h2>{stock.ticker}</h2>
                        <p>{stock.name}</p>
                      </div>
                      <SparklineChart data={stock.history || []} />
                      <div className="Stock-Details">
                        <p>${stock.price.toFixed(2)}</p>
                        <p className={stock.change < 0 ? "text-red-500" : "text-green-500"}>
                          {stock.change.toFixed(2)}%
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>

            </div>
            </>
          )}


      {/* Search Results */}
      <div className="search-results">
        {searchResults
        // .filter(isStockValid) // ✅ Ensures only valid stocks are rendered
        .map((stock) => (
          
          <div 
            key={stock.ticker} 
            style={{
            }}
            onClick={() => toggleStockSelection(stock)}
          >
            <div>
            <Card key={stock.ticker} className="card" >
              
                  <CardContent>
                  {selectedStocks.find((s) => s.ticker === stock.ticker) ? <CheckCircle size={24} weight="fill"/> : <PlusCircle size={24} color="#878787" />}
                    <div className="CompanyDetails">
                    <div className="ticker">
                            <div className={stock.change >= 0 ? "ticker-icon positive" : "ticker-icon negative"}>
                              {stock.change >= 0 ? "▲" : "▼"}
                            </div>
                            <h2 className="font-semibold">{stock.ticker}</h2>
                          </div>
                          <p className="text-sm text-gray-500">{stock.name || "Unknown Stock"}</p>
                    </div>
                    <SparklineChart data={stock.history || []} isPositive={stock.change >= 0} ticker={stock.ticker} />
                    <div className="Stock-Details">
                      <p className="text-lg font-bold">
                        ${stock.price ? stock.price.toFixed(2) : "N/A"}
                      </p>
                      <p className={stock.change < 0 ? "text-red-500 font-semibold" : "text-green-500 font-semibold"}>
                        {stock.change ? stock.change.toFixed(2) + "%" : "N/A"}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              {/* <Typography variant="buttonALT">{stock.ticker}</Typography>
              <Typography variant="supportingCaption" style={{ color: theme.colors.contentSecondary }}>
                {stock.name}
              </Typography> */}
            </div>
          </div>
        ))}
      </div>

      {/* Selected Stocks */}
      {selectedStocks.length > 0 && (
        <div className="selected-stocks" style={{ marginTop: spacing.m }}>
          <Typography variant="headlineMedia">Selected Stocks</Typography>
          {selectedStocks.map((stock) => (
            <div key={stock.ticker} style={{ padding: spacing.s, backgroundColor: theme.colors.fillTertiary, marginTop: spacing.xs }}>
              <Typography variant="buttonALT">{stock.ticker}</Typography>
            </div>
          ))}
        </div>
      )}

      <div className="fixed-footer">
        <button 
          onClick={handleSaveWatchlist} 
          className="preview-button"
          disabled={selectedStocks.length === 0}

        >
          Save Watchlist
        </button>
      </div>


      {/* Save Button */}
      <button 
        onClick={handleSaveWatchlist} 
        style={{
          marginTop: spacing.m,
          padding: spacing.m,
          backgroundColor: theme.colors.fillCTA,
          color: "white",
          borderRadius: borderRadius.m,
          width: "100%",
        }}
        disabled={!watchlistName || selectedStocks.length === 0}
      >
        Save Watchlist
      </button>
    </div>
  );
};

export default CreateWatchlist;
